import styled from 'styled-components';

export const BannerContainer = styled.div`
  width: 100%;
  height: 200px; 
  background-image: url(/imagem-fundo-2.png);
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }
`;

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #ffffff;
  z-index: 1;
  max-width: 800px;
  padding: 0 20px;
`;

export const BannerTitle = styled.h1`
  font-size: 36px; 
  font-weight: 700;
  margin-bottom: 5px;
`;

export const BannerIntro = styled.p`
  font-size: 16px;
  line-height: 1.6;
`;

export const ContactPageSection = styled.section`
  padding: 60px 0;
`;

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 50px;
  align-items: stretch;

  @media screen and (max-width: 768px){
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

export const ContactInfo = styled.div`
  color: #424242;
  background-color: #ffffff;
  padding: 40px;
  box-shadow: 0px 1px 5px rgba(0,0,0,0.15);
  border-radius: 8px;
  border: 1px solid #02391E;

  h3 {
    font-size: 28px;
    color: #02391E;
    margin-bottom: 20px;
  }

  p {
    margin-bottom: 20px;
    line-height: 1.6;
  }

  strong {
    font-weight: 700;
    color: #02391E;
  }

  p a {
    color: #424242;
    text-decoration: none;
    transition: color 0.2s ease-in-out;

    &:hover {
      color: #02391E;
      text-decoration: underline;
    }
  }
`;

export const FormIntroText = styled.p`
  margin-bottom: 25px;
  color: #424242;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
`;

export const FormContainer = styled.div`
  padding: 40px;
  background-color: #ffffff;
  box-shadow: 0px 1px 5px rgba(0,0,0,0.15);
  border-radius: 8px;
  border: 1px solid #02391E;
  
  label {
    display: block;
    width: 100%;
    margin-bottom: 15px;
    color: #575757;
    font-size: 14px;
    font-weight: 500;
  }

  input,
  textarea {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
    border-radius: 4px;
    border: 1px solid   #B6B6B6;
    font-size: 16px;
    box-sizing: border-box;
  }

  textarea {
    resize: vertical;
  }

  button {
    background-color: #02391E; 
    color: #ffffff; 
    border: none;
    width: 100%;
    height: 45px;
    border-radius: 8px; 
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #03572d;
    }
  }
`;

export const WhatsappSection = styled.div`
  margin-top: 20px;
`;

export const WhatsappButton = styled.a`
  display: inline-block;
  text-align: center;
  text-decoration: none;
  background-color: #02391E;
  color: #ffffff; 
  border: none;
  padding: 12px 35px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 5px;

  &:hover {
    background-color: #03572d;
  }
`;